import axiosInstance from "./interceptor";

// axiosInstanceeService.js

export const get = async (url, config = {}, onLoading) => {
  try {
    onLoading(true);
    const response = await axiosInstance.get(url, config);
    onLoading(false);
    return response;
  } catch (error) {
    if (error?.response?.data?.message === "jwt expired") {
      handleLogout();
    }
    onLoading(false);
    // return error; // Re-throw for explicit handling
  }
};

export const post = async (url, data, config = {}, onLoading) => {
  try {
    onLoading(true);
    const response = await axiosInstance.post(url, data, config);
    onLoading(false);
    return response;
  } catch (error) {
    onLoading(false);
     console.log('error received--------->', error);
  }
};

export const put = async (url, data, config = {}) => {
  try {
    const response = await axiosInstance.put(url, data, config);
    return response.data;
  } catch (error) {
  }
};

export const patch = async (url, data, config = {}, onLoading) => {
  try {
    onLoading(true);
    const response = await axiosInstance.patch(url, data, config);
    onLoading(false);
    return response;
  } catch (error) {
     onLoading(false);
  }
};

export const remove = async (url, config = {}) => {
  try {
    const response = await axiosInstance.delete(url, config);
    return response;
  } catch (error) {
     console.log('error received--------->', error);
  }
};



export const logout = () => {
  localStorage.removeItem("authToken");
  delete axiosInstance.defaults.headers.common["Authorization"];
};

// const handleAxiosError = (error) => {
//   if (error.response) {
//     // Server responded with a status other than 2xx
//     const { status, data } = error.response;
//     console.error(`Error ${status}:`, data);
//     toast.error(data.message || "An error occurred");
//   } else if (error.request) {
//     // No response received
//     console.error("No response received:", error.request);
//     // toast.error("The server is not responding. Please try again later.");
//   } else {
//     // Something happened in setting up the request
//     console.error("Axios error:", error.message);
//     toast.error("An error occurred while making the request.");
//   }
// };

// fetch paginated data
export const fetchPaginatedData = async (url, page, pageSize = 10) => {
  const response = await get(`${url}?page=${page}&pageSize=${pageSize}`);
  return response;
};

// upload file
// export const uploadFile = async (url, file) => {
//   const formData = new FormData();
//   formData.append("file", file);

//   const response = await axiosInstance.post(url, formData, {
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   });

//   return response.data;
// };

export const buildQueryParams = (params) => {
  const queryString = new URLSearchParams(params).toString();
  return queryString ? `?${queryString}` : "";
};

export const fetchFilteredData = async (url, filters) => {
  const queryParams = buildQueryParams(filters);
  return get(`${url}${queryParams}`);
};

export const handleLogout = () => {
  localStorage.removeItem("token");
  window.location.href = "/signin";
};